import React from 'react';
import { ApolloLink, InMemoryCache, ApolloClient } from '@apollo/client';
import { useSerialized } from '@shopify/react-html';
import { createSsrExtractableLink, ApolloProvider } from '@shopify/react-graphql';
import { useLazyRef } from '@shopify/react-hooks';
import { useRequestHeader } from '@shopify/react-network';
import { isServer } from './utilities.mjs';
import { createCsrfLink } from './csrf-link.mjs';
import { createRequestIdLink } from './request-id-link.mjs';

function GraphQLUniversalProvider({
  id = 'apollo',
  quiltRails = true,
  addRequestId = true,
  children,
  createClientOptions
}) {
  const [initialData, Serialize] = useSerialized(id);
  const requestID = useRequestHeader('X-Request-ID');
  const [client, ssrLink] = useLazyRef(() => {
    const server = isServer();
    const defaultClientOptions = {
      ssrMode: server,
      ssrForceFetchDelay: 100,
      connectToDevTools: !server
    };
    const clientOptions = createClientOptions();
    const ssrLink = server ? createSsrExtractableLink() : undefined;
    const csrfLink = quiltRails ? createCsrfLink() : undefined;
    const requestIdLink = addRequestId && requestID ? createRequestIdLink(requestID) : undefined;
    const finalLink = clientOptions.link || undefined;
    const link = ApolloLink.from([...(ssrLink ? [ssrLink] : []), ...(csrfLink ? [csrfLink] : []), ...(requestIdLink ? [requestIdLink] : []), ...(finalLink ? [finalLink] : [])]);
    const cache = clientOptions.cache ? clientOptions.cache : new InMemoryCache();
    const apolloClient = new ApolloClient({
      ...defaultClientOptions,
      ...clientOptions,
      link,
      cache: initialData ? cache.restore(initialData) : cache
    });
    return [apolloClient, ssrLink];
  }).current;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, children), /*#__PURE__*/React.createElement(Serialize, {
    data: () => ssrLink ? ssrLink.resolveAll(() => client.extract()) : undefined
  }));
}

export { GraphQLUniversalProvider };
